/*eslint no-useless-constructor: 0*/

import { IRegistrationData } from "../../rule-engine-core/Common/IRegistrationData";
import { FormControl } from "../Controls/FormControl";

// decorator function to create registry for unpacking json

export enum ControlType {
    Control = "Control",
    Container = "Container",
}

export class RegistrationData implements IRegistrationData<FormControl> {
    category: string;
    name: string;
    icon?: JSX.Element;
    typeOfControl: ControlType;
    prototype: any;

    constructor(
        prototype: any,
        category: string,
        name: string,
        typeOfControl: ControlType = ControlType.Control,
        icon?: JSX.Element,
    ) {
        this.prototype = prototype;
        this.category = category;
        this.name = name;
        this.icon = icon;
        this.typeOfControl = typeOfControl;
    }

    create(): FormControl {
        throw new Error("not implemented");
    }
}

export function RegisterFormControl(
    controlExample: FormControl,
    category: string,
    typeOfControl: ControlType = ControlType.Control,
    icon?: JSX.Element,
) {
    let prototype = Object.getPrototypeOf(controlExample);
    let name = controlExample.__type;
    UIControlRegistration[name] = new RegistrationData(prototype, category, name, typeOfControl, icon);
}

export class ControlRegistrationClass {
    [key: string]: RegistrationData;
}

export const UIControlRegistration = new ControlRegistrationClass();
